/******************
 * Media queries: use these in your scripts, based on scss breakpoints
 * If IE11 is a requirement, replace this block with the commented version below, and use hard coded values.
 * Usage ex1:
        if (media.default.matches) {
            //screen is bigger then 1100px
        }
    * Usage ex2:
        const paragraph = document.querySelector('p')

        function makeBlueOnDesktop(e) {
            if (e.matches) {
                //media query matches, make paragraph blue
                paragraph.style.color = 'blue'
            }
            else {
                //media query does not match, remove blue coloring
                paragraph.style.color = ''
            }
        }

        media.default.addListener(makeBlueOnDesktop)
******************/
import { util } from '~/core';

/*const media = blue.util.media = {}
window.addEventListener('DOMContentLoaded', () => {
    const doc = getComputedStyle(document.documentElement)
    media.xs = window.matchMedia(`(min-width: ${doc.getPropertyValue('--media_xs')}`)
    media.sm = window.matchMedia(`(min-width: ${doc.getPropertyValue('--media_sm')}`)
    media.md = window.matchMedia(`(min-width: ${doc.getPropertyValue('--media_md')}`)
    media.lg = window.matchMedia(`(min-width: ${doc.getPropertyValue('--media_lg')}`)
    media.xl = window.matchMedia(`(min-width: ${doc.getPropertyValue('--media_xl')}`)
})*/

// replace lines 27 - 35 with this if you need to support IE11
const media = blue.util.media = {
    xs: window.matchMedia("(min-width: 0)"),
    sm: window.matchMedia("(min-width: 576px)"),
    md: window.matchMedia("(min-width: 768px)"),
    lg: window.matchMedia("(min-width: 992px)"),
    xl: window.matchMedia("(min-width: 1200px)")
}

export default media
util.media = media
